import { CmsFooterContactsProperties, CmsFooterSitemapProperties, CmsFooterSocialProperties } from "./CmsFooterContactsProperties";
import { CmsLoginDealsProperties } from "./CmsLoginDealsProperties";
import { CmsLoginMainContentProperties } from "./CmsLoginMainContentProperties";

export class CmsLogoProperties {
  sr: number = 0;
  logo: string = "";
}
export class CmsLoginHeaderProperties {
  sr: number = 0;
  navItemName: string = "";
  navItemLink: string = "";
}
export class GetAllCmsLoginProperties {
  navigation: CmsLoginHeaderProperties[] = [];
  loginLanding: CmsLoginMainContentProperties[] = [];
  deals: CmsLoginDealsProperties[] = [];
  footerContacts: CmsFooterContactsProperties[] = [];
  footerSitemap: CmsFooterSitemapProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
  logo = new CmsLogoProperties();
}
